module.exports = __webpack_public_path__ + "img/contact_text.e114f640.svg";